import { render, staticRenderFns } from "./NoticePage.vue?vue&type=template&id=54f3d553&scoped=true"
import script from "./NoticePage.vue?vue&type=script&lang=js"
export * from "./NoticePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f3d553",
  null
  
)

export default component.exports